import { format } from 'date-fns';

export function toDateKey(d: Date): string {
    return format(d, 'yyyy-MM-dd');
}

export function generateRandomVeryLargePositiveInteger(): number {
    return Math.floor(Math.random() * 10000000000000) + 10000000000000;
}

export function decodeJwtPayload<T = Record<string, unknown>>(token: string): T {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format');
    }
  
    const payload = parts[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      + '='.repeat((4 - (parts[1].length % 4)) % 4);
  
    return JSON.parse(atob(payload)) as T;
  }